module.exports = __webpack_public_path__ + "img/doc2-white.6e753d07.png";